import { render, staticRenderFns } from "./mobileOrEmailValidation.vue?vue&type=template&id=4dc2010e&"
import script from "./mobileOrEmailValidation.vue?vue&type=script&lang=js&"
export * from "./mobileOrEmailValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports